import { CanDeactivateFn } from '@angular/router';
import { TestResultsComponent } from './test-results.component';

export const canDeactivateTestResults: CanDeactivateFn<TestResultsComponent> = (component) => {
  if (component.hasUnsavedChanges()) {
    return component.confirmDeactivate();
  }
  return true;
};
